var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusicalNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext1_1",
    width: 40,
    height: 40,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ext1_1_i",
    d: "M29.0575 10.1517C29.0575 9.75421 28.7125 9.45421 28.3225 9.50671L15.595 11.1567C15.2725 11.2017 15.025 11.4792 15.025 11.8092V22.0167C14.5825 21.8667 14.1025 21.7767 13.6075 21.7767C11.2 21.7767 9.25 23.7342 9.25 26.1417C9.25 28.5492 11.2 30.4992 13.6075 30.4992C16.015 30.4992 17.965 28.5492 17.965 26.1417C17.965 26.0517 17.9575 25.9542 17.9575 25.8642V15.4392C17.9575 15.1467 18.175 14.9067 18.46 14.8692L25.4725 13.9617C25.8175 13.9167 26.125 14.1867 26.125 14.5317V19.4292C25.675 19.2717 25.195 19.1892 24.7 19.1892C22.2925 19.1892 20.3425 21.1392 20.3425 23.5467C20.3425 25.9542 22.2925 27.9042 24.7 27.9042C27.1075 27.9042 29.0575 25.9542 29.0575 23.5467C29.0575 23.5392 29.0575 23.5392 29.0575 23.5317V10.1517Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicalNote);
export default __webpack_public_path__ + "static/media/MusicalNote.bb89e0cf.svg";
export { ForwardRef as ReactComponent };